import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const DiscountedPriceAndProductImageContainer: React.FC<Props> = ({ children }) => {
    const theme: Theme = useTheme();

    const style = css`
        ${theme.breakpoints.down("sm")} {
            position: relative;
        }
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
}

export default DiscountedPriceAndProductImageContainer;

